function trackingComponent(orderId) {
  return {
    trackingUrl: null, // Holds the tracking URL
    orderId: orderId, // The order ID passed from the button

    // Fetch the tracking URL when the component initializes
    init() {
      if (!this.orderId) {
        console.error("Order ID is missing.");
        return;
      }

      const backendUrl = `https://admin.loveinfaith.work/eve/get-orderdetails.php?order_id=${this.orderId}`;

      fetch(backendUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          // Assuming the API response directly includes the tracking URL as a string
          if (data.tracking_url) {
            console.log(data.tracking_url);
            this.trackingUrl = data.tracking_url;
          } else {
            console.log("No tracking URL found for this order.");
          }
        })
        .catch((error) => {
          console.error("Error fetching the tracking URL:", error);
        });
    },

    // Function to navigate to the tracking URL
    goToTrackingUrl() {
      if (this.trackingUrl) {
        window.open(this.trackingUrl, "_blank");
      } else {
        console.log("No tracking URL available.");
      }
    },
  };
}
